import { META_LAYOUT, META_HEADER_TITLE } from "@core/constants";
import { ETAB_ROUTES, ETAB_LAYOUTS } from "@etab/config";
import { LoadingManager } from "@core/managers/loading.manager";
import { ACTION_ACTIVATION_GET_DEMAND_RECAP, ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION } from "@etab/stores/types";
import { useActivationStore } from "@etab/stores/activation";
import { useSubscriptionStore } from "@etab/stores/subscription";
import { NotificationsManager } from "@core/managers/notifications.manager";

import UpfrontPage from "./Upfront.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.upfront.path,
      name: ETAB_ROUTES.upfront.name,
      meta: {
        [META_LAYOUT]: ETAB_LAYOUTS.pricing,
        [META_HEADER_TITLE]: "",
      },
      async beforeEnter(to, from, next) {
        const activationStore = useActivationStore();
        const subscriptionStore = useSubscriptionStore();
        const demandId = to.params.demandId;
        try {
          LoadingManager.show();
          if (demandId) {
            await Promise.all([
              activationStore[ACTION_ACTIVATION_GET_DEMAND_RECAP](demandId),
              subscriptionStore[ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION](),
            ]);
            next();
          } else {
            NotificationsManager.error({ message: "ERRORS.@GETRECAP_ERROR" });
          }
        } catch (error) {
          NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
          throw error;
        } finally {
          LoadingManager.hide();
        }
      },
      component: UpfrontPage,
    },
  ];
}
